import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestUpdates from "./components/LatestUpdates";
import TrackingFeature from "./components/TrackingFeature";
import WeeklySchedule from "./components/WeeklySchedule";
import HotNew from "./components/HotNew";
import Genres from "./components/Genres";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function CtaBanner() {
  return (
    <section className="relative mx-auto max-w-7xl px-4 md:px-6">
      <div className="relative overflow-hidden rounded-3xl bg-primary-600">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20manhwa%20illustration%20banner%20with%20dynamic%20comic%20ink%20splashes%20and%20silhouette%20characters%20leaping%20into%20action%2C%20warm%20vermillion%20orange%20amber%20and%20dark%20tones%2C%20high%20energy%20motion%2C%20artistic%20abstract%20composition&width=1400&height=500&seq=cta-manhwa-banner&orientation=landscape"
            alt="虚空韩漫网追更行动号召横幅背景"
            className="h-full w-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-600/80 to-primary-600/30"></div>
        </div>
        <div className="relative z-10 flex flex-col items-start gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-16">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
              把韩漫连载进度，交给虚空韩漫网
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
              最新话即时同步、追更列表自动提醒、每周更新排期一目了然，现在就开始你的轻松追更之旅。
            </p>
          </div>
          <a
            href="#updates"
            className="inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-8 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-flashlight-fill text-lg"></i>
            立即开始追更
          </a>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <Hero />
      <LatestUpdates />
      <TrackingFeature />
      <WeeklySchedule />
      <CtaBanner />
      <HotNew />
      <Genres />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}